import { createClient } from "@connectrpc/connect";
import { ProjectService } from "@reliquo/proto/project/connect";
import { createTransport } from "./transport";

/**
 * Returns a typed ConnectRPC ProjectService client with the given access token
 * injected as a Bearer header.
 */
export function getProjectClient(accessToken: string | null) {
  return createClient(ProjectService, createTransport(accessToken));
}
